<template>
  <div style="min-width: 1200px; min-height: 95vh;">
    <q-card style="min-height: 95vh;">
      <q-form ref="form">
        <div class="row q-pa-md">
          <div class="col-12">
            <div class="d-flex justify-content-between">
              <h4 class="mt-0 mb-3" style="font-size: 26px; font-weight: 300;"> ESET Retail Sales </h4>
              <span class="d-block">
                <q-btn @click="closeDialog" class="q-ml-auto" flat icon="close" round size="small"></q-btn>
              </span>
            </div>
          </div>

          <div class="col-4 q-pa-md pb-0" style="border-right: 1px solid lightgray">
            <div>
              <div class="mb-4">
                <q-select :options="customerArr"
                          :rules="[val=>val && typeof(val) === 'object' || 'Please select Customer']"
                          @filter="filterCustomer" class="searchBox w-100 p-2 mb-3" @input="onSelectCustomer"
                          @blur="onPopupHide" clearable label="Select Customer*" outlined
                          style="width: 41.66%" filled use-input v-model="customer">
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey"> No results</q-item-section>
                    </q-item>
                  </template>
                  <template v-slot:option="scope">
                    <q-item v-bind="scope.itemProps" v-on="scope.itemEvents" @click="onSelectCustomerOption(scope.opt)">
                      <q-item-section>
                        <q-item-label v-html="scope.opt.name"></q-item-label>
                        <q-item-label caption>{{ toLower(scope.opt.email) }}</q-item-label>
                        <q-item-label caption>{{ scope.opt.mobile }}</q-item-label>
                      </q-item-section>
                    </q-item>
                  </template>
                  <template v-slot:selected-item="scope"> {{ scope.opt.name }}</template>
                </q-select>
              </div>
              <div class="my-4">
                <q-input :rules="[v => !v || v.length === 10 || 'Invalid mobile']"
                         class="searchBox p-2 my-3" label="Customer Mobile" lazy-rules mask="##########"
                         v-model="customerMobile"></q-input>
              </div>
              <div class="my-4">
                <q-input :rules="[v => !v || emailPattern.test(v) || 'Invalid Email']"
                         class="searchBox p-2 my-3" label="Customer Email" lazy-rules type="email"
                         v-model="customerEmail"></q-input>
              </div>
              <div class="my-4">
                <q-input class="searchBox p-2 my-3" label="Invoice No."
                         v-model="invoiceNumber"></q-input>
              </div>
              <div class="mt-4">
                <q-input class="searchBox p-2 my-3" filled label="Invoice Date"
                         mask="##/##/####"
                         v-model="invoiceDateComp">
                  <template v-slot:append>
                    <q-icon class="cursor-pointer " name="event">
                      <q-popup-proxy ref="invoiceDate" transition-hide="scale"
                                     transition-show="scale">
                        <q-date @input="() => $refs.invoiceDate.hide()"
                                v-model="invoiceDate"/>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
              <div class="mt-4 mb-0 pb-0">
                <q-input class="searchBox" label="Note/Remark" style="height: auto" type="textarea"
                         v-model="invoiceNote"></q-input>
              </div>

            </div>
          </div>

          <div class="col-8 q-pa-md">

            <!--Radio-->
            <div class="transferType mb-3">
              <q-option-group v-model="transferType" :options="transferOptions"
                              color="blue-10" inline @input="onChangeTransferType"></q-option-group>
            </div>

            <!--search box-->
            <div v-show="transferType==='searchByBatch'">
              <div style="width: 100%">
                <div class="d-flex px-3">
                  <div class="w-100">
                    <q-select :options="batchArr" @filter="searchBatch" class="searchBox w-100 p-2 mb-3" clearable
                              label="Search by batch no. to transfer" outlined style="width: 41.66%"
                              @input="onSelectBatch" use-input v-model="selectedBatch">
                      <template v-slot:no-option>
                        <q-item>
                          <q-item-section class="text-grey">
                            No results
                          </q-item-section>
                        </q-item>
                      </template>
                      <template v-slot:option="scope">
                        <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                          <q-item-section>
                            <q-item-label v-html="scope.opt.batch"></q-item-label>
                            <q-item-label caption>{{ scope.opt.Product ? scope.opt.Product.name : '' }}</q-item-label>
                          </q-item-section>
                        </q-item>
                      </template>
                      <template v-slot:selected-item="scope">
                        {{ scope.opt.batch }} {{ scope.opt.Product ? ' (' + scope.opt.Product.name + ')' : '' }}
                      </template>
                    </q-select>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-between q-pa-md pb-0">
                <div style="width: 100%">
                  <div class="mb-3">
                    <div class="d-flex justify-content-between" style="align-items: center;">
                      <p class="mb-0">Select Sub-Batch Numbers</p>
                      <!--                                            <div>-->
                      <!--                                                <q-btn @click="addToCart" class="pd-btn" :style="transferType==='openBoxes'?'margin-right: 16px;margin-top: 10px;':'margin-right: 0px;margin-top: -6px;'">-->
                      <!--                                                    Add-->
                      <!--                                                </q-btn>-->
                      <!--                                            </div>-->
                    </div>
                  </div>
                  <div class="sectionOne position-relative" style="height: 38vh !important;">

                    <div class="overflow-hidden" style="min-height: 200px !important; margin-top: 0px; ">

                      <div class="py-3 section-list" v-for="inventory in productInventoryArr">
                        <q-checkbox :val="inventory.id" v-model="groupOneSelection">
                          <div>
                            <span style="font-size: 16px; font-weight: 500;">{{ inventory.serial }}</span>
                          </div>

                          <div>
                            <span style="font-size: 14px; color: #878787">{{ inventory.Product.name }}</span>
                          </div>
                        </q-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--accordion-->
            <div v-show="transferType==='openBoxes'">
              <div style="width: 100%">
                <div class="d-flex px-3">
                  <div class="w-100">
                    <q-list bordered class="rounded-borders">
                      <template v-for="(batch, index) in openBatches" v-if="batch.ProductInventories.length">
                        <q-expansion-item>
                          <template slot="header">
                            <q-item-section>{{ batch.batch }}</q-item-section>
                            <q-item-section side>{{ batch.ProductInventories.length }}</q-item-section>
                          </template>

                          <q-card>
                            <q-card-section>
                              <q-list bordered padding style="max-height: 200px;overflow-y: scroll;">
                                <q-item :key="i" tag="label" v-for="(inventory, i) in batch.ProductInventories">
                                  <q-item-section side top>
                                    <q-checkbox :val="inventory.id" v-model="groupOneSelection"></q-checkbox>
                                  </q-item-section>

                                  <q-item-section>
                                    <q-item-label>{{ inventory.serial }}
                                      <span style="float:right;"><!--{{batch.orderItemStatus}}--></span>
                                    </q-item-label>
                                    <q-item-label caption>{{ inventory.Product.name }}</q-item-label>
                                  </q-item-section>
                                </q-item>
                              </q-list>
                            </q-card-section>
                          </q-card>
                        </q-expansion-item>
                      </template>
                      <template v-if="!openBatches.length"><span class="text-red">No Open Batches Available</span>
                      </template>
                    </q-list>
                  </div>
                </div>
              </div>
            </div>

            <!--addButton-->
            <transition name="fade">
              <div class="d-flex"
                   v-if="groupOneSelection.length&&(transferType==='openBoxes'||productInventoryArr.length)">
                <q-space></q-space>
                <q-btn @click="addToCart" class="pd-btn mt-3"
                       :style="transferType==='openBoxes'?'margin-right: 16px;margin-top: 10px;':'margin-right: 16px;margin-top: -6px;'">
                  Add to Cart
                </q-btn>
              </div>
            </transition>
          </div>

          <div class="col-12 q-pa-md">
            <div class="d-flex justify-content-between q-pa-md" style="align-items: center">
              <div style="width: 100%">
                <h6 class="mb-3">Selected Sub-Batch Numbers</h6>
                <q-table :columns="columns2" :data="groupTwoSelection" dense :pagination.sync="pagination"
                         flat row-key="name" table-class="table-class"
                         table-header-style="background-color:#f9f9f9fa;color: black;height: 36px;">
                  <template v-slot:body-cell-action="props">
                    <q-td :props="props">
                      <q-btn flat round small color="red" size="12px" @click="removeInventoryItem(props)"
                             icon="delete_outline" class="delete-btn">
                        <q-tooltip content-style="font-size: 12px" :offset="[10, 10]">Remove SKU</q-tooltip>
                      </q-btn>
                    </q-td>
                  </template>
                  <template v-slot:body-cell-productKey="props">
                    <q-td :props="props">
                      <q-input class="searchBox" placeholder="Enter product key" mask="XXXX-XXXX-XXXX-XXXX-XXXX"
                               filled v-model="props.row.productKey"></q-input>
                    </q-td>
                  </template>
                  <template v-slot:body-cell-activationDate="props">
                    <q-td :props="props">
                      <q-input class="py-2" filled v-model="props.row.activationDate" mask="##-##-####" :rules="[val=>val && val.length>0 || 'Please select Activation date',
                                                                  val => val.length && datePattern.test(val) || 'Invalid Date']">
                        <template v-slot:prepend>
                          <q-icon name="event" class="cursor-pointer">
                            <q-popup-proxy transition-show="scale" transition-hide="scale"
                                           :ref="'qDateProxy'+props.row.__index">
                              <q-date v-model="props.row.activationDate" mask="DD-MM-YYYY"
                                      @input="forceUpdateTable('qDateProxy'+props.row.__index)"></q-date>
                            </q-popup-proxy>
                          </q-icon>
                        </template>
                      </q-input>
                    </q-td>
                  </template>
                  <template v-slot:body-cell-expiryDate="props">
                    <q-td :props="props">
                      {{
                        props.row.activationDate ? moment(props.row.activationDate, 'DD-MM-YYYY').
                            add(props.row.Product.validity ? props.row.Product.validity : 365, 'days').
                            format('DD-MM-YYYY') : '-'
                      }}
                    </q-td>
                  </template>
                  <template v-slot:body-cell-remark="props">
                    <q-td :props="props">
                      <q-input class="searchBox" filled v-model="props.row.remark"></q-input>
                    </q-td>
                  </template>
                  <template v-slot:bottom="props">
                    <q-space></q-space>
                    <q-btn @click="onAddOrder" class="pd-btn float-right mt-3" style="margin-right: -14px"
                           v-show="groupTwoSelection.length">Transfer
                    </q-btn>
                  </template>
                  <!--<template v-slot:bottom-row="props">-->
                  <!--<q-btn @click="onAddOrder" class="pd-btn float-right" v-show="groupTwoSelection.length">Transfer</q-btn>-->
                  <!--</template>-->
                </q-table>
              </div>
            </div>
          </div>

        </div>
      </q-form>
    </q-card>


  </div>
</template>

<script>
import moment from 'moment'
import { GET_CUSTOMERS } from '../../graphql/queries/Customers'
import { INSERT_CUSTOMER } from '../../graphql/mutations/customer'
import {
  GET_INVENTORY_BY_BATCH,
  GET_PRODUCT_INVENTORY_BY_BATCHID,
  GET_OPEN_BATCHES,
} from '../../graphql/queries/products'
import { INSERT_ORDER_ITEMS, INSERT_ORDERS } from '../../graphql/mutations/products'
import { UPDATE_ORDER } from '../../graphql/mutations/Order'

export default {
  name: 'RetailSales',
  apollo: {
    customerArr: {
      query: GET_CUSTOMERS,
      fetchPolicy: 'network-only',
      variables () {return { orgId: this.user.orgId }},
      result ({ data, loading }) {
        if (!loading) {
          this.temp_customerArr = JSON.parse(JSON.stringify(data.customerArr))
        }
      },
    },
    openBatches: {
      query: GET_OPEN_BATCHES,
      fetchPolicy: 'network-only',
      variables () {return { ownedBy: this.user.orgId }},
      result ({ data, loading }) {
        if (!loading) {
          let self = this
          this.productInventory_openBatches = []
          data.openBatches.forEach(function (batch) {
            batch.ProductInventories.forEach(function (inventory) {
              self.productInventory_openBatches.push(inventory)
            })
          })
        }
      },
    },
  },
  data: function () {
    return {
      moment: moment,
      user: JSON.parse(localStorage.getItem('user')),
      emailPattern: new RegExp(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
      datePattern: new RegExp(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/),
      transferType: 'searchByBatch',
      transferOptions: [
        { label: 'Search By Batch', value: 'searchByBatch' },
        { label: 'Open Boxes', value: 'openBoxes' }],
      customerArr: [],
      temp_customerArr: [],
      customer: '',
      customerMobile: '',
      customerEmail: '',
      invoiceDate: null,
      invoiceDateComp: null,
      invoiceNumber: '',
      orderDate: moment(),
      orderDateComp: moment().format('DD/MM/YYYY'),
      invoiceNote: '',
      batchFilter: '%%',
      batchArr: [],
      selectedBatch: '',
      tempValue: null,
      productInventoryArr: [],
      groupOneSelection: [],
      groupTwoSelection: [],
      groupFourSelection: [],
      openBatches: [],
      productInventory_openBatches: [],
      columns2: [
        { name: 'sku', label: 'SKU', field: row => row.sku, align: 'left', sortable: true },
        { name: 'serialNumber', label: 'Sub-batch No', field: row => row.serial, align: 'left', sortable: true },
        { name: 'productKey', label: 'Product Key', field: 'productKey', align: 'left', sortable: true },
        { name: 'activationDate', label: 'Activation Date', field: 'activationDate', align: 'left', sortable: true },
        { name: 'expiryDate', label: 'Expiry Date', field: 'expiryDate', align: 'left', sortable: true },
        { name: 'remark', label: 'Remark', field: 'remark', align: 'left', sortable: false },
        { name: 'action', label: '', field: 'action', align: 'left', sortable: true },
      ],
      pagination: { rowsPerPage: 200 },

    }
  },
  watch: {
    invoiceDate (val) {
      this.invoiceDateComp = moment(val).format('DD/MM/YYYY')
    },
    orderDate (val) {
      this.orderDateComp = moment(val).format('DD/MM/YYYY')
    },
  },
  methods: {
    closeDialog () {
      this.$emit('closeRetailSalesDialog', false)
    },
    optionsFn (date) {
      return date >= moment().subtract(7, 'days').format('YYYY/MM/DD') && date <= moment().format('YYYY/MM/DD')
    },
    onChangeTransferType () {
      // this.groupOneSelection = []
      // this.groupTwoSelection = []
      // this.onSelectBatch()
      // this.selectedBatch = null
    },
    addToCart () {
      let tempArr = this.groupOneSelection.map((id) => this.groupTwoSelection.find((obj) => obj.id === id) ||
          this.productInventoryArr.find((obj) => obj.id === id) ||
          this.productInventory_openBatches.find((obj) => obj.id === id))
      tempArr.forEach(function (curnt) {               //Autofill activationDate by Today's date
        if (!curnt.hasOwnProperty('activationDate')) {
          curnt.activationDate = moment().format('DD-MM-YYYY')
        }
      })
      this.groupTwoSelection = JSON.parse(JSON.stringify(tempArr))       //To fix referencing error(To avoid -> on update groupTwoSelection updates other arrays)
    },
    removeInventoryItem (prop) {
      this.groupTwoSelection.splice(prop.row.__index, 1)
      this.groupOneSelection.splice(this.groupOneSelection.indexOf(prop.row.id), 1)
    },
    onSelectCustomer (val) {
      this.tempValue = null
      if (val) {
        this.customerMobile = val.mobile
        this.customerEmail = val.email
      } else {
        this.customerMobile = ''
        this.customerEmail = ''
        this.customer = ''
      }
    },
    onSelectCustomerOption (row) {
      this.customer = { 'id': row.id, 'name': row.name, 'mobile': row.mobile, 'email': row.email }
      this.customerMobile = row.mobile
      this.customerEmail = row.email
    },
    onSelectBatch (val) {
      if (val) {
        this.fetchProductInventory(val.id)
      } else {
        this.productInventoryArr = []
      }
    },
    async fetchProductInventory (batchId) {
      let response = await this.$apollo.query({
        query: GET_PRODUCT_INVENTORY_BY_BATCHID,
        fetchPolicy: 'network-only',
        variables: {
          ownedBy: this.user.orgId,
          batchId: batchId,
          status: 'InStock',
        },
      })
      if (response.data) {
        this.productInventoryArr = response.data.ProductInventory
      }
    },
    onPopupHide () {
      if (this.tempValue) {
        this.customerArr.push({ name: this.tempValue })
        this.customer = { name: this.tempValue }
      }
    },
    filterCustomer (val, update, abort) {
      if (val === '') {
        update(() => {
          this.customerArr = JSON.parse(JSON.stringify(this.temp_customerArr))
        })
        return
      }

      update(() => {
        this.tempValue = val
        this.customerArr = this.temp_customerArr.filter(function (el) {
          return (el.name?.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
              el.email?.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
              el.mobile?.toLowerCase().indexOf(val.toLowerCase()) > -1)
        })
      })
    },
    async searchBatch (val, update, abort) {
      let splitted = val.split(' ')
      if (splitted.length <= 1) {
        if (val.length < 1) {
          abort()
          return
        }
        let response = await this.$apollo.query({
          query: GET_INVENTORY_BY_BATCH,
          fetchPolicy: 'network-only',
          variables: {
            ownedBy: this.user.orgId,
            batchFilter: '%' + val + '%',
            status: 'InStock',
          },
        })
        if (response.data) {
          this.batchArr = response.data.BatchTable
        }
        update(() => {})
      }
    },
    onAddOrder () {
      let self = this
      this.$refs['form'].validate().then(success => {
        if (success && self.customer.id) {
          self.confirm(self.insertOrder, self.customer.id)
        } else if (success) {
          self.confirm(self.insertCustomer)
        }
      })
    },
    confirm (callback, customerId) {
      let self = this
      this.$q.dialog({
        title: 'Confirm',
        message: 'Are you sure?',
        cancel: true,
        persistent: false,
      }).onOk(() => {
        callback(customerId)
      }).onCancel(() => {
        // console.log('>>>> Cancel')
      })
    },
    async insertOrder (customerId) {
      let self = this
      let orderRequest = {
        id: this.generateUUID(),
        date: moment(),                     //set Today's date for Retail-Sales
        from: self.user.orgId,
        to: customerId,
        lineItemCounts: this.groupTwoSelection.length,
        status: 'InTransit',
        placedBy: self.user.id,
        notes: '',
        invoiceNumber: self.invoiceNumber,
        invoiceNote: self.invoiceNote,
        invoiceDate: self.invoiceDate ? self.invoiceDate : null,
        orderType: 2,
      }
      let response = await this.$apollo.mutate({
        mutation: INSERT_ORDERS,
        variables: orderRequest,
      })
      if (response.data) {
        this.insertOrderItems(orderRequest)
      }
    },
    insertOrderItems (orderRequest) {
      let self = this
      let orderItemRequest
      let counter = this.groupTwoSelection.length
      for (var i = 0; i < this.groupTwoSelection.length; i++) {
        let inv = this.groupTwoSelection[i]
        orderItemRequest = {
          id: self.generateUUID(),
          orderId: orderRequest.id,
          qty: orderRequest.lineItemCounts,
          from: orderRequest.from,
          to: orderRequest.to,
          notes: '',
          sellType: '2',
          batchId: inv.batchId,
          productInventoryId: inv.id,
          productId: inv.Product.id,
          status: 'Sold',
          meta: {
            activationDate: inv.activationDate, productKey: inv.productKey, remark: inv.remark,
            expiryDate: moment(inv.activationDate, 'DD-MM-YYYY').
                add(inv.Product.validity ? inv.Product.validity : 365, 'days').
                format('DD-MM-YYYY'),
          },
        }
        this.$apollo.mutate({
          mutation: INSERT_ORDER_ITEMS,
          variables: orderItemRequest,
        }).then(function (response) {
          counter--
          if (counter === 0) {
            // self.updateOrder(orderRequest.id)
          }
        })

      }
      this.groupOneSelection = []
      this.groupTwoSelection = []
      this.$q.notify('Retail Sales Order.js Placed Successfully')
      this.$emit('closeRetailSalesDialog', false)
    },
    async updateOrder (orderId) {
      let response = await this.$apollo.mutate({
        mutation: UPDATE_ORDER,
        variables: { id: orderId, status: 'Sold' },
      })
      if (response.data) {}
    },
    async insertCustomer () {
      let customerRequest = {
        id: this.generateUUID(),
        name: this.customer.name,
        mobile: this.customerMobile || null,
        email: this.customerEmail || null,
        orgId: this.user.orgId,

      }
      let response = await this.$apollo.mutate({
        mutation: INSERT_CUSTOMER,
        variables: customerRequest,
      })
      if (response.data) {
        this.insertOrder(customerRequest.id)
      }
    },

    generateUUID () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    forceUpdateTable (name) {
      this.groupTwoSelection = JSON.parse(JSON.stringify(this.groupTwoSelection))
      this.$refs[name].hide()
    },
  },
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

/deep/ .q-table__middle {
  border: 1px solid #d0d0d087;
}

</style>
